import OrderBar from './OrderBar';
import connectContianer from './OrderBarContainer';

export default connectContianer(OrderBar);
